import { TabLines } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledTabLines = styled(TabLines)`
  padding: 0px 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid var(--border-default);
`;
